import { useMemo } from 'react';

interface RemainingTimeProps {
  expiresAt: string | null;
  className?: string;
}

function formatRemainingTime(expiresAt: string): string {
  const now = new Date();
  const expiry = new Date(expiresAt);
  const diffMs = expiry.getTime() - now.getTime();

  if (diffMs <= 0) {
    return '期限切れ';
  }

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays > 0) {
    return `残り ${String(diffDays)} 日`;
  }
  if (diffHours > 0) {
    return `残り ${String(diffHours)} 時間`;
  }
  if (diffMinutes > 0) {
    return `残り ${String(diffMinutes)} 分`;
  }
  return '残りわずか';
}

export function RemainingTime({
  expiresAt,
  className,
}: RemainingTimeProps): React.ReactElement {
  const remainingText = useMemo(() => {
    if (!expiresAt) {
      return '無期限';
    }
    return formatRemainingTime(expiresAt);
  }, [expiresAt]);

  return <span className={className}>{remainingText}</span>;
}
